import React, { Dispatch, SetStateAction } from "react";
import { Header } from "../app/Header";
import SubMenuTwoCol from "../styled/SubMenuTwoCol";
import { Heading } from "../ui/Heading";
import { SubMenuToggle } from "../ui/SubMenuToggle";

export const HeaderWithFilter = ({
  title,
  controlsId,
  isFilterOpen,
  setIsFilterOpen,
  children,
}: {
  children?: React.ReactNode;
  title: string;
  controlsId: string;
  isFilterOpen: boolean;
  setIsFilterOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  return (
    <Header>
      <SubMenuTwoCol alignSelf="center" colGapSpace={8}>
        <Heading space={7} heading="h3" inline html={title} />

        
        <SubMenuTwoCol width="auto" alignSelf="center" colGapSpace={8}>
          <div>{children}</div>
          <SubMenuToggle
            label="FILTER"
            controlsId={controlsId}
            isExpanded={isFilterOpen}
            onClick={() => {
              setIsFilterOpen(!isFilterOpen);
              window.scrollTo({
                left: 0,
                top: 0,
                behavior: "smooth",
              });
            }}
          />
        </SubMenuTwoCol>
      </SubMenuTwoCol>
    </Header>
  );
};
